<template>
  <textarea
    v-if="dsComponentDetails.version === VersionOptions.LEGACY"
    :id="internalId"
    data-sb-regression="sb-text-area"
    :maxlength="maxLengthValue || attrs.maxlength"
    :data-sb-automation="$attrs['data-sb-automation'] || 'sb-text-area'"
    :rows="attrs.rows || 2"
    :cols="attrs.cols || 20"
    :class="classes"
    :type="type"
    v-bind="attrs"
    v-on="attrs"
    @input="inputChanged"
    @focus="handleFocus"
    @blur="handleBlur"
  />
  <sb-text-area-next
    v-else
    :id="internalId"
    :maxlength="maxLengthValue || attrs.maxlength"
    :data-sb-automation="$attrs['data-sb-automation'] || 'sb-text-area'"
    data-sb-regression="sb-text-area"
    :rows="attrs.rows || 2"
    :cols="attrs.cols || 20"
    :class="classes"
    :type="type"
    v-bind="attrs"
    v-on="attrs"
    @input="inputChanged"
    @focus="handleFocus"
    @blur="handleBlur"
  />
</template>

<script>
import labelHelper from '@src/utils/mixins/labelHelperMixin';
import fieldHelper from '@src/utils/mixins/fieldHelperMixin';
import textFieldHelper from '@src/utils/mixins/textFieldHelperMixin';
import { versionedComponentsMixin } from '@src/mixins/versionedComponents';
import SbTextAreaNext from '@src/components/Input/SbTextAreaNext.vue';
/**
 * Text Inputs allows users to input text. :)
 */
export default {
  name: 'SbTextarea',
  components: {
    SbTextAreaNext,
  },
  mixins: [labelHelper, fieldHelper, textFieldHelper, versionedComponentsMixin],
  props: {
    /**
     * Text alignment of the input box. Can be `left|center|right`
     */
    align: {
      type: String,
      default: 'left',
      validator: (value) => {
        return value.match(/(left|center|right)/);
      },
    },
    /**
     * Type of text input. Can be `text|tel|email|url|search|password`
     */
    type: {
      type: String,
      default: 'text',
      validator: (value) => {
        return value.match(/(text|tel|email|url|search|password)/);
      },
    },
    id: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      required: false,
      default: null,
    },
    /**
     * If you are using this input as part of the SbField pattern with SbFieldHelperText, counter is used to set the upper limit of the Field.
     * *This does not actually set a maxlength property on the input. It is only used as a visual inside the SbFieldHelperText.*
     */
    counter: {
      type: Number,
      default: null,
    },
    /**
     * Allow the text area to be of a fixed size
     */
    resizable: {
      type: Boolean,
      default: true,
    },
    /**
     * Sets the max possible length on the text input. If you are using this input as part of the SbField pattern with SbFieldHelperText, maxlength is used to set the upper limit of the Field and appear in SbFieldHelperText.
     */
    maxlength: {
      type: Number,
      default: null,
    },
  },
  computed: {
    classes() {
      const classList = ['sb-textarea'];

      if (this.align !== 'left') classList.push(this.$style[`sbTextarea${this.align}`]);
      if (!this.resizable) classList.push(this.$style.sbTextareaNotResizable);

      return classList;
    },
  },
};
</script>

<style lang="scss" module>
@use '@src/components/Input/style/sb-textarea.module.scss';
</style>
